import React from 'react';

export function WelcomeMessage() {
  const suggestions = [
    "Tell me about yourself",
    "What can you help me with?",
    "Let's brainstorm ideas",
    "Help me solve a problem"
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full text-center px-4">
      <div className="max-w-2xl">
        <h2 className="text-3xl font-bold mb-4 bg-gradient-to-r from-primary-500 to-secondary-500 bg-clip-text text-transparent">
          Welcome to AI Companion
        </h2>
        
        <p className="mb-8 text-lg text-base-300">
          I'm here to help you think, create, and explore ideas. I remember our conversations
          and learn about what matters to you.
        </p>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
          {suggestions.map((suggestion, index) => (
            <button
              key={index}
              className="px-4 py-3 transition text-left text-sm bg-base-800 hover:bg-base-700 rounded-lg"
              onClick={() => {
                const input = document.querySelector('textarea');
                if (input) {
                  input.value = suggestion;
                  input.dispatchEvent(new Event('input', { bubbles: true }));
                  input.focus();
                }
              }}
            >
              <span className="mr-2 text-accent-500">→</span>
              {suggestion}
            </button>
          ))}
        </div>
        
        <div className="flex items-center justify-center gap-4 text-sm text-base-500">
          <div className="flex items-center gap-1">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
            <span>Private & Secure</span>
          </div>
          
          <div className="flex items-center gap-1">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
            <span>Fast Responses</span>
          </div>
          
          <div className="flex items-center gap-1">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>Always Available</span>
          </div>
        </div>
      </div>
    </div>
  );
}